import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { types as sdkTypes } from '../../util/sdkLoader';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { formatDateRangeForTimezone } from '../../util/genericHelpers';
import { createResourceLocatorString } from '../../util/routes';
import LandingSearchForm from './LandingSearchForm/LandingSearchForm';

import css from './SearchNavBar.module.css';
import moment from 'moment';

const { LatLng, LatLngBounds } = sdkTypes;

function SearchNavBar(props) {
  const { isTopbarSearch, showTopbarSearch } = props;
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  const handleSubmit = values => {
    const { keywords = null, location = null, dates, activities = null } = values || {};

    const searchQuery = {};
    if (keywords) searchQuery.keywords = keywords;
    const { search = 'Thailand', selectedPlace } = location || {};
    const defaultBounds = new LatLngBounds(
      new LatLng(20.464995, 105.636637),
      new LatLng(5.612851, 97.343447)
    );
    const { bounds = defaultBounds } = selectedPlace || {};
    Object.assign(searchQuery, { address: search, bounds });

    if (dates?.startDate) {
      const start = dates.startDate;
      const end = dates.endDate;

      // Pass both into your formatter:
      const dateRange = formatDateRangeForTimezone({
        startDate: start,
        endDate: end,
      });

      if (dateRange) {
        searchQuery.dates = dateRange;
      }
    }

    history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, searchQuery));
  };

  return (
    <LandingSearchForm
      rootClassName={css.landingSearchForm}
      onSubmit={handleSubmit}
      isTopbarSearch={isTopbarSearch}
      showTopbarSearch={showTopbarSearch}
    />
  );
}

export default SearchNavBar;
